<template>
    <div class="box">
        <div class="row">
            <label for="newPlayerName">Nom du joueur : </label>
            <input type="text" v-model="newPlayer.name" id="newPlayerName" placeholder="Nom"/>
        </div>
        <div class="row">
            <label for="newPlayerImage">Photo : </label>
            <input type="url" v-model="newPlayer.image" id="newPlayerImage" placeholder="Url photo"/>
        </div>
        <div class="row">
            <label for="newPlayerDesc">Description : </label>
            <textarea v-model="newPlayer.desc" id="newPlayerDesc" placeholder="Description"></textarea>
        </div>
        <div class="row">
            <label for="newPlayerStatus">Statut : </label>
            <div>
                <input type="checkbox" v-model="newPlayer.status" id="newPlayerStatus"/>
                <span v-if="!newPlayer.status">Non </span><span>Disponible</span>
            </div>
        </div>
        <div class="row">
            <label for="newPlayerPrice">Prix : </label>
            <input type="number" v-model="newPlayer.price" id="newPlayerPrice" placeholder="Prix"/>
        </div>
        <input type="button" value="Enregistrer new player" v-on:click="addPlayer" :disabled="isDisabled"/>
    </div>
</template>

<script>
    export default {
        name: "AddPlayer",
        props: {},
        methods: {
            addPlayer: function () {
                // On utilise les event pour faire remonter des infos
                this.$emit('players-add-player', this.newPlayer);
                this.newPlayer.name = "";
                this.newPlayer.desc = "";
                this.newPlayer.image = "";
                this.newPlayer.status = true;
                this.newPlayer.price = "";
            }

        },
        computed: {
            isDisabled() {
                // On verifie que tout les champ son remplie pour debloquer le bouton valider
                return !(this.newPlayer.name !== "" && this.newPlayer.desc !== "" && this.newPlayer.image !== "" && this.newPlayer.price !== "")
            }
        },
        data() {
            return {
                newPlayer: {
                    name: "",
                    desc: "",
                    image: "",
                    status: true,
                    price: "",
                },
            }
        },
    }
</script>

<style scoped>
    .box {
        display: flex;
        flex-direction: column;
        border: 2px solid chartreuse;
        border-radius: 20px;
        padding: 6px;
        margin: 2px;
    }

    .row {
        display: flex;
    }

    .row > label {
        flex: 1;
    }

    .row > input, .row > textarea, .row > div {
        display: flex;
        flex: 2;
    }
</style>